import _toConsumableArray from "D:/suggestcollect/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/staticImg/loading@2x.gif';
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_overlay, {
    "z-index": "9999",
    show: _ctx.$store.state.information.loadingShow
  }, {
    "default": _withCtx(function () {
      return _toConsumableArray(_cache[0] || (_cache[0] = [_createElementVNode("div", {
        "class": "wrapper"
      }, [_createElementVNode("div", {
        "class": "block"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: ""
      })])], -1)]));
    }),
    _: 1
  }, 8, ["show"])]);
}